module.exports = __webpack_public_path__ + "img/ivy-logo.196ad895.png";